import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)


document.addEventListener('DOMContentLoaded', () => {
  const preloaderSection = document.getElementById('preloaderSection')
  const ctnPreloader = document.querySelector('#ctn-preloader')
  const preloader = document.querySelector('#preloader')
  const body = document.querySelector('body')

  setTimeout(function () {
    ctnPreloader.classList.add('loaded')
    body.classList.remove('no-scroll-y')

    if (ctnPreloader.classList.contains('loaded')) {
      body.classList.remove('no-scroll-y')
      setTimeout(() => {
        preloaderSection.remove()
        ScrollTrigger.refresh()

      }, 1000)
    }
  }, 500);
})

